<script setup>
import { computed, ref } from "vue"
import { useAuthStore } from '@/Stores/auth'
const auth = useAuthStore()

const props = defineProps({
	columnDefs: {
		type: Array,
		default: () => ([]),
	},
})

const emit = defineEmits({
	'toggle-column': {
		type: Object,
		default: () => ({}),
	},
})

// some columns should only be shown to admins
const adminOnlyColumns = [
	"xero_id",
]

// AGGrid uses a boolean "hide", when true the column is hidden. However we want the UI to have a positive checkbox
// for a positive action, so we need to do some transitive bool flipping here.
const cols = computed(() => props.columnDefs.map(col => {
		return {
			...col,
			show: !col.hide,
		}
	})
	// if the column is admin only, and the user is not an admin, hide it
	.filter(col => {
		if(adminOnlyColumns.includes(col.field) && !auth.isAdmin){
			return false
		}
		return true
	})
)

function setColumn(event, data){
	var col = cols.value.find(x => x.field == data.field)
	col.hide = !event.target.checked
	col.show = event.target.checked
	emit('toggle-column', {field: col.field, hide: col.hide})
}
</script>

<template>
	<p class="text-sm mb-4">Show/Hide columns</p>
	<div
		v-for="column in cols"
		:key="column.field"
	>
		<Input
			type="checkbox"
			:label="column.field"
			:name="column.field"
			:testid="column.field"
			v-model="column.show"
			:checked="column.show"
			@change="setColumn($event, column)"
		/>

	</div>
</template>